import { FeatureMapItem } from '~app/pages/Pricing/transformers/types';

const Grow2792FeatureMap: FeatureMapItem[] = [
  {
    featureItemKey: 'grow_2792_survey_create_limit',
    features: ['survey_create_limit', 'create_question_limit'],
  },
  {
    featureItemKey: 'grow_2792_user',
  },
  {
    featureItemKey: 'grow_2792_survey_branding',
  },
  {
    featureItemKey: 'grow_2792_question_types',
  },
  {
    featureItemKey: 'grow_2792_create_custom_theme_enabled',
  },
  {
    featureItemKey: 'grow_2792_website_embed',
  },
  {
    featureItemKey: 'grow_2792_zapier_integrations',
  },
  {
    featureItemKey: 'grow_2792_text_analysis',
  },
  {
    featureItemKey: 'grow_2792_multilingual',
  },
  {
    featureItemKey: 'grow_2792_a_b_testing',
  },
  {
    featureItemKey: 'grow_2792_analyze_export_enabled',
  },
];

export default Grow2792FeatureMap;
